import { ActionType } from '../actions/view';
import { IReduxAction } from 'typings/common';

export interface StateModel {
  handler: any | null;
}

// Initial state
export const initialState: StateModel = {
  handler: null,
};

// Reducer used to handle page, tabs and other view changing
// Allows to set handler function that will be called when user change the view
// Example of usage: show confirmation modal when user leave a page without saving a form
const view = (state = initialState, action: IReduxAction) => {
  const { type, payload, key } = action;

  switch (type) {
    case ActionType.SET_CHANGE_VIEW_HANDLER:
      return {
        ...state,
        [key]: payload,
      };

    case ActionType.CLEAN_UP:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default view;
